module.exports = __webpack_public_path__ + "static/media/top_banner_pc_02.df7a0833.webp";